import { ApiError } from '../../../../consts/api';

export const errorObjectToStringTransformer = (error: ApiError): string => error.error.serverError.message;
